import React from 'react';
import Header from './Header';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import Typography from '@mui/material/Typography';
// import ImageList from '@mui/material/ImageList';
// import ImageListItem from '@mui/material/ImageListItem';
// import ImageListItemBar from '@mui/material/ImageListItemBar';
// import Button from '@mui/material/Button';
import './style/Research.css';

/**
 *
 * @return {object}
 */
export default function Research() {
  return (
    <div>
      <Header></Header>
      <Container container spacing={2} sx={{width: 2/3}} className='background'>
        <h4 className='title'>Research</h4>
        <h5 className='subtitle'>my ongoing and past projects</h5>
        <Grid container spacing={4} sx={{'paddingTop': '3vh'}}>
          {itemData.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Grid container spacing={2}>
                {/* Image section */}
                <Grid item xs={12} sm={4}>
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.img}
                    sx={{
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                </Grid>

                {/* Description section */}
                <Grid item xs={12} sm={8}>
                  <p className='project'>
                    {item.title}
                  </p>
                  <p className='tagline'>
                    {item.des}
                  </p>
                  <p className='citation'>
                    {item.citation}
                  </p>
                  <p className='tagline'>
                    <a className="link" href={item.link} target="_blank"
                      rel="noopener noreferrer">{item.website}</a>
                    <a className="link" href={item.doiLink} target="_blank"
                      rel="noopener noreferrer">{item.doi}</a> {item.filler}
                    <a className="link" href={item.posterLink} target="_blank"
                      rel="noopener noreferrer">{item.poster}</a>
                  </p>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}

const itemData = [
  {
    img: './assets/research/exoplanet.jpg',
    title: 'extrasolAR planets',
    des: 'An augmented reality application to explore stars' +
     ' and discover exoplanets in the planetarium',
    poster: 'POSTER',
    posterLink: './assets/research/extrasolAR_PERC2025.pdf',
  },
  {
    img: './assets/research/orbitSim.jpg',
    title: 'Orbit Sim',
    des: 'A web application to explore and learn Kepler’s' +
    ' Laws with paper, drawings, and a camera',
    website: 'WEBSITE',
    link: 'https://atlas-acme-lab.github.io/orbitsim-app/',
    filler: ' ◦ ',
    poster: 'VIDEO',
    posterLink: 'https://www.youtube.com/watch?v=sJQlYDNoPIs',
  },
  {
    img: './assets/research/failRetry.png',
    title: 'Fail + Retry',
    des: 'A Macro-Level Taxonomy of the Challenge and Failure Process in Games',
    citation: 'Marjorie Ann Cuerdo, Anika Mahajan, Josh Mao, and Edward' +
    ' Melcer. (2023) In 2023 IEEE Conference on Games (CoG).',
    doi: 'DOI',
    doiLink: 'https://doi.org/10.1109/CoG57401.2023.10333199',
    filler: ' ◦ ',
    poster: 'POSTER',
    posterLink: './assets/research/AnikaMahajanKoretPoster.pdf',
  },
  {
    img: './assets/research/deathRebirth.png',
    title: 'Death + Rebirth',
    des: 'A Study on Player Experience and' +
      ' Failure Design through Respawning Mechanics',
    citation: 'Marjorie Ann Cuerdo, Anika Mahajan, and Edward Melcer. (2021)' +
    ' In 2021 IEEE Conference on Games (CoG).',
    doi: 'DOI',
    doiLink: 'https://doi.org/10.1109/CoG52621.2021.9618894',
  },
];
